document.querySelectorAll('[data-dec-pyo]').forEach((root) => {
  const family = root.querySelector('[data-dec-family]');
  const basePhoto = root.querySelector('[data-dec-base-photo]');
  const examplePhoto = root.querySelector('[data-dec-example-photo]');
  const visualCaption = root.querySelector('.dec-pyo__visual-caption');
  function updateBasePhoto(option) {
    if (!basePhoto || !examplePhoto) return;
    const url = option?.dataset.photo?.trim();
    basePhoto.hidden = !url;
    examplePhoto.hidden = Boolean(url);
    if (visualCaption) visualCaption.textContent = option?.dataset.name
      ? (url ? `${option.dataset.name} · Fabric sample preview.` : `${option.dataset.name} · Sample photo coming soon. Specifications below are current.`)
      : 'Concept visual · choose a fabric base and upload your own artwork.';
    if (url) {
      const image = basePhoto.querySelector('img');
      image.src = url;
      image.alt = `${option.dataset.name} — ${option.dataset.madeToOrder === 'true' ? 'fabric sample photo' : 'unprinted fabric texture'}`;
      basePhoto.querySelector('figcaption').textContent = `${option.dataset.name} · ${option.dataset.madeToOrder === 'true' ? 'Fabric sample photo' : 'Unprinted base fabric'}. Your artwork is printed to order.`;
    }
    const visualStrip = root.querySelector('[data-dec-visual-strip]');
    if (visualStrip) {
      const sampleSet = option?.value === 'urban-rib'
        ? { name: 'Urban Rib', src: 'urbanSrc', href: 'urbanHref' }
        : option?.value === '7x5-poly-rib-knit'
          ? { name: '7x5 Poly Rib Knit', src: 'rib7x5Src', href: 'rib7x5Href' }
          : option?.value === '3x2-european-brushed-rib-fleece'
            ? { name: '3x2 European Brushed Rib Fleece', src: 'rib3x2Src', href: 'rib3x2Href' }
            : option?.value === 'light-double-brushed-poly'
              ? { name: 'Light Double Brushed Poly', src: 'lightPolySrc', href: 'lightPolyHref' }
              : option?.value === 'medium-double-brushed-poly'
                ? { name: 'Medium Double Brushed Poly', src: 'mediumPolySrc', href: 'mediumPolyHref' }
                : option?.value === 'poly-waffle-knit'
                  ? { name: 'Poly Waffle Knit', src: 'polyWaffleSrc', href: 'polyWaffleHref' }
                  : null;
      visualStrip.hidden = Boolean(option?.value && !sampleSet);
      visualStrip.querySelectorAll('[data-dec-strip-image]').forEach((image) => {
        image.src = sampleSet ? image.dataset[sampleSet.src] : image.dataset.defaultSrc;
        image.alt = sampleSet ? `${sampleSet.name} colour sample` : image.alt;
      });
      visualStrip.querySelectorAll('[data-dec-strip-link]').forEach((link) => {
        link.href = sampleSet ? link.dataset[sampleSet.href] : link.dataset.defaultHref;
        if (!link.dataset.modalBound) {
          link.dataset.modalBound = 'true';
          link.addEventListener('click', (event) => {
            event.preventDefault();
            let modal = root.querySelector('[data-dec-image-modal]');
            if (!modal) {
              modal = document.createElement('div');
              modal.dataset.decImageModal = '';
              modal.hidden = true;
              modal.setAttribute('role', 'dialog');
              modal.setAttribute('aria-modal', 'true');
              modal.innerHTML = '<div data-dec-modal-backdrop></div><div data-dec-modal-panel><button type="button" data-dec-modal-close aria-label="Close image">×</button><img data-dec-modal-image alt=""></div>';
              document.body.append(modal);
              const style = document.createElement('style');
              style.textContent = '[data-dec-image-modal]{position:fixed;inset:0;z-index:10000;display:grid;place-items:center;padding:24px}[data-dec-image-modal][hidden]{display:none}[data-dec-modal-backdrop]{position:absolute;inset:0;background:rgba(15,31,54,.58)}[data-dec-modal-panel]{position:relative;z-index:1;max-width:min(860px,90vw);max-height:80vh;padding:14px;background:#fff;border-radius:14px;box-shadow:0 18px 60px rgba(15,31,54,.28)}[data-dec-modal-image]{display:block;max-width:calc(90vw - 28px);max-height:calc(80vh - 28px);width:auto;height:auto;border-radius:8px}[data-dec-modal-close]{position:absolute;right:6px;top:4px;z-index:2;width:32px;height:32px;border:0;border-radius:50%;background:#20345a;color:#fff;font-size:24px;line-height:1;cursor:pointer}';
              document.head.append(style);
              const close = () => { modal.hidden = true; };
              modal.querySelector('[data-dec-modal-backdrop]').addEventListener('click', close);
              modal.querySelector('[data-dec-modal-close]').addEventListener('click', close);
              document.addEventListener('keydown', (keyEvent) => { if (keyEvent.key === 'Escape') close(); });
            }
            const modalImage = modal.querySelector('[data-dec-modal-image]');
            modalImage.src = link.href;
            modalImage.alt = link.querySelector('img')?.alt || 'Fabric sample enlarged';
            modal.hidden = false;
          });
        }
      });
      const captions = visualStrip.querySelectorAll('[data-dec-strip-caption]');
      if (captions.length >= 2) {
        captions[0].textContent = sampleSet ? `${sampleSet.name} colour sample 1 · click to enlarge` : 'Texture detail';
        captions[1].textContent = sampleSet ? `${sampleSet.name} colour sample 2 · click to enlarge` : 'Design and colour planning';
      }
    }
  }

  const base = root.querySelector('[data-dec-base]');
  const originalOptions = Array.from(base.querySelectorAll('option[data-family]'));
  const specs = root.querySelector('[data-dec-specs]');
  const priceNode = root.querySelector('[data-dec-price]');
  const variantInput = root.querySelector('[data-dec-variant]');
  const fabricProperty = root.querySelector('[data-dec-fabric-property]');
  const quantity = root.querySelector('[data-dec-quantity]');
  const total = root.querySelector('[data-dec-total]');
  const totalValue = root.querySelector('[data-dec-total-value]');
  const submit = root.querySelector('[data-dec-submit]');
  const formNote = root.querySelector('[data-dec-form-note]');
  const designNameInput = root.querySelector('input[name="properties[Design name]"]');
  const artwork = root.querySelector('input[type="file"][name="properties[Artwork]"]');
  const rights = root.querySelector('[data-dec-rights]');
  const variantsElement = root.querySelector('[data-dec-variants]');
  let variants = [];
  if (variantsElement) {
    try {
      const parsed = JSON.parse(variantsElement.textContent);
      variants = Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error('DEC FABRICS: unable to read printed fabric variants.', error);
    }
  }
  let selectedPrice = 0;
  let selectedKgPerYard = null;
  const weightEstimate = root.querySelector('[data-dec-weight-estimate]');
  const matchingCurrency = root.dataset.decCurrency === 'USD';

  const formatPrice = (amount) => new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount);

  function validYards() {
    const yards = Number(quantity?.value);
    return Number.isSafeInteger(yards) && yards >= 1 ? yards : null;
  }

  function updateTotal() {
    const yards = validYards();
    const artworkReady = !artwork || artwork.required === false || Boolean(artwork.files?.length);
    const rightsReady = !rights || Boolean(rights.checked);
    const missing = [];
    if (!artworkReady) missing.push('upload artwork');
    if (!rightsReady) missing.push('confirm artwork rights');
    if (weightEstimate) weightEstimate.textContent = selectedKgPerYard && yards
      ? `This fabric: ${(selectedKgPerYard * yards).toFixed(4)} kg. Your cart combines all fabrics and adds packaging once.`
      : '';
    if (submit && variantInput?.value) {
      submit.disabled = yards === null || !artworkReady || !rightsReady;
      submit.textContent = yards === null
        ? 'Enter a whole number of yards'
        : missing.length
          ? `Complete: ${missing.join(' and ')}`
          : `Add ${yards} yard${yards === 1 ? '' : 's'} to cart`;
    }
    if (!selectedPrice || yards === null || !total || !totalValue) {
      if (total) total.hidden = true;
      return;
    }
    totalValue.textContent = formatPrice(selectedPrice * yards);
    total.hidden = false;
  }

  function resetSelection(message) {
    updateBasePhoto(null);
    selectedPrice = 0;
    selectedKgPerYard = null;
    if (weightEstimate) weightEstimate.textContent = '';
    const baseHeading = root.querySelector('[data-dec-base-heading]');
    if (baseHeading) baseHeading.textContent = 'Find your fabric';
    specs.hidden = true;
    priceNode.textContent = 'Choose a fabric';
    if (variantInput) variantInput.value = '';
    if (fabricProperty) fabricProperty.value = '';
    if (total) total.hidden = true;
    if (submit) {
      submit.disabled = true;
      submit.textContent = 'Choose a fabric to continue';
    }
    if (formNote && message) formNote.textContent = message;
  }

  family.addEventListener('change', () => {
    const matches = originalOptions.filter((option) => option.dataset.family === family.value);
    base.replaceChildren(new Option(family.value ? 'Select your fabric base' : 'Choose a family first', ''));
    matches.forEach((option) => {
      const visibleOption = option.cloneNode(true);
      visibleOption.hidden = false;
      base.add(visibleOption);
    });
    base.disabled = matches.length === 0;
    resetSelection('Artwork and print details are confirmed before production.');
  });

  base.addEventListener('change', () => {
    const selected = base.selectedOptions[0];
    if (!selected || !selected.value) {
      resetSelection();
      return;
    }

    root.querySelector('[data-dec-composition]').textContent = selected.dataset.composition;
    root.querySelector('[data-dec-width]').textContent = selected.dataset.width;
    root.querySelector('[data-dec-weight]').textContent = selected.dataset.weight;
    specs.hidden = false;
    updateBasePhoto(selected);
    const baseHeading = root.querySelector('[data-dec-base-heading]');
    if (baseHeading) baseHeading.textContent = selected.dataset.name;

    const width = /^(\d+(?:\.\d+)?)cm$/i.exec(selected.dataset.width);
    const gsm = /^(\d+(?:\.\d+)?)GSM$/i.exec(selected.dataset.weight);
    selectedKgPerYard = width && gsm ? Math.round(Number(width[1]) * Number(gsm[1]) / 10 * 0.9144) / 10000 : null;
    selectedPrice = Number(selected.dataset.price);
    if (!Number.isFinite(selectedPrice) || selectedPrice <= 0) selectedPrice = 0;
    priceNode.textContent = selectedPrice ? `${formatPrice(selectedPrice)} / yard` : 'Price available on request';
    if (fabricProperty) fabricProperty.value = selected.dataset.name;
    updateTotal();
    if (!variantInput || !submit) return;
    const variant = variants.find((item) => item.title === selected.dataset.name);
    const matchingPrice = variant && Number.isFinite(selectedPrice) && selectedPrice > 0
      && Math.abs(Number(variant.price) - selectedPrice) < 0.01;
    const madeToOrder = selected.dataset.madeToOrder === 'true';
    const variantCanOrder = variant && (variant.available || madeToOrder) && matchingPrice && matchingCurrency;
    variantInput.value = variantCanOrder ? variant.id : '';
    submit.disabled = !variantInput.value;
    updateTotal();
    if (!matchingCurrency) {
      submit.textContent = 'Contact us to order';
      formNote.textContent = 'These estimates are in USD. Please contact us to confirm pricing in your checkout currency.';
    } else if (!variant) {
      submit.textContent = 'This fabric is not ready to order';
      formNote.textContent = 'This base is not linked to the ordering product yet. Please contact us.';
    } else if (!matchingPrice) {
      submit.textContent = 'This fabric is not ready to order';
      formNote.textContent = 'This base needs a final price check before ordering. Please contact us.';
    } else if (!variant.available && !madeToOrder) {
      submit.textContent = 'This fabric is currently unavailable';
      formNote.textContent = 'Please contact us for availability and the next production date.';
    } else {
      formNote.textContent = madeToOrder
        ? 'Made to order. Artwork and print details are confirmed before production.'
        : 'Artwork and print details are confirmed before production.';
    }
  });

  if (quantity) {
    quantity.addEventListener('input', () => {
      updateTotal();
    });
  }

  if (artwork) {
    artwork.addEventListener('change', () => {
      const file = artwork.files?.[0];
      const fileStatus = root.querySelector('[data-dec-file-status]');
      if (fileStatus) fileStatus.textContent = file ? file.name : 'No file selected';
      const allowed = /\.(jpe?g|png|tiff?|pdf|psd)$/i;
      artwork.setCustomValidity(file && !allowed.test(file.name) ? 'Please upload a JPG, PNG, TIFF, PDF or PSD file.' : '');
      if (formNote && file) formNote.textContent = artwork.validationMessage || `Selected artwork: ${file.name}`;
      updateTotal();
    });
  }

  rights?.addEventListener('change', updateTotal);

  const form = root.querySelector('form');
  const urlParams = new URLSearchParams(window.location.search);
  const requestedDesignName = urlParams.get('design_name');
  const requestedDesignImage = urlParams.get('design_image');
  const libraryDesignSelected = Boolean(requestedDesignName && requestedDesignImage);
  const libraryUploadLabel = root.querySelector('label[for^="dec-artwork-"]');
  const libraryUploadBox = libraryUploadLabel?.nextElementSibling;
  const libraryUploadHelp = libraryUploadBox?.nextElementSibling;
  const libraryVisualCaption = root.querySelector('.dec-pyo__visual-caption');
  if (libraryDesignSelected) {
    [libraryUploadLabel, libraryUploadBox, libraryUploadHelp].forEach((element) => {
      if (element) element.hidden = true;
    });
    if (artwork) artwork.removeAttribute('required');
    const libraryNotice = document.createElement('p');
    libraryNotice.className = 'dec-pyo__fine';
    libraryNotice.textContent = 'Original Design selected. No artwork upload is required.';
    libraryNotice.setAttribute('data-dec-library-notice', '');
    libraryUploadBox?.parentNode?.insertBefore(libraryNotice, libraryUploadBox.nextSibling);
    if (libraryVisualCaption) libraryVisualCaption.textContent = 'Preview your selected Original Design on the fabric base.';
    const libraryStep = root.querySelector('.dec-pyo__steps span:nth-child(2)');
    if (libraryStep) libraryStep.textContent = '02  Choose your design';
  }
  if (requestedDesignName && designNameInput) {
    designNameInput.value = requestedDesignName;
    designNameInput.dispatchEvent(new Event('input', { bubbles: true }));
  }
  if (form && libraryDesignSelected) {
    artwork.required = false;
    const libraryField = document.createElement('input');
    libraryField.type = 'hidden';
    libraryField.name = 'properties[Library design preview]';
    libraryField.value = requestedDesignImage;
    form.append(libraryField);
    const preview = document.createElement('figure');
    preview.className = 'dec-library-design-preview';
    const previewImage = document.createElement('img');
    previewImage.src = requestedDesignImage;
    previewImage.alt = requestedDesignName + ' preview';
    previewImage.loading = 'lazy';
    const caption = document.createElement('figcaption');
    caption.textContent = 'Selected library design: ' + requestedDesignName + '. The selected library image will be used for printing; contact us if you need changes.';
    preview.append(previewImage, caption);
    const upload = root.querySelector('.dec-pyo__upload');
    if (upload) upload.before(preview);
    if (formNote) formNote.textContent = 'Selected library design loaded. Confirm your fabric, repeat and scale, then add it to cart.';
  }
  if (form) form.addEventListener('submit', (event) => {
    if (!variantInput || !variantInput.value || !base.value || validYards() === null || !(artwork?.files?.length || libraryDesignSelected) || !rights?.checked || !form.checkValidity()) {
      event.preventDefault();
      form.reportValidity();
      if (formNote) formNote.textContent = libraryDesignSelected
        ? 'Choose a fabric, enter whole yards and confirm permission before adding to cart.'
        : 'Choose a fabric, enter whole yards, upload artwork and confirm permission before adding to cart.';
      return;
    }
    submit.disabled = true;
    submit.textContent = 'Adding your custom fabric…';
  });

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) updateTotal();
  });
  const requestedBase = urlParams.get('base');
  const requestedOption = originalOptions.find((option) => option.value === requestedBase);
  if (requestedOption) {
    family.value = requestedOption.dataset.family;
    family.dispatchEvent(new Event('change'));
    base.value = requestedOption.value;
    base.dispatchEvent(new Event('change'));
  }

});
/* DEC artwork size preview */
(()=>{document.querySelectorAll('[data-dec-pyo]').forEach(r=>{let f=r.querySelector('form'),i=r.querySelector('input[type=file][name="properties[Artwork]"]'),u=r.querySelector('.dec-pyo__upload');if(!f||!i||!u)return;let c=document.createElement('div');c.className='dec-artwork-card';c.hidden=1;c.innerHTML='<img><div><b></b><small></small><small></small></div><button type="button" data-clear>×</button><button type="button" data-view disabled>View size</button>';u.after(c);let im=c.querySelector('img'),nm=c.querySelector('b'),sz=c.querySelectorAll('small')[0],msg=c.querySelectorAll('small')[1],vw=c.querySelector('[data-view]'),add=n=>{let e=document.createElement('input');e.type='hidden';e.name=n;f.append(e);return e},ww=add('properties[Artwork width (in)]'),hh=add('properties[Artwork height (in)]'),rr=add('properties[Artwork preview repeat]'),m=document.createElement('div');m.className='dec-size-modal';m.hidden=1;m.innerHTML='<div data-close></div><section><header>Pattern preview <button type="button" data-close>×</button></header><main><div class="p"><canvas></canvas><p>Preview shows print-scale proportions; the original file is preserved.</p></div><aside><b>Size settings</b><small data-file></small><div class="pres"><button type="button" data-size="12">12″</button><button type="button" data-size="24">24″</button><button type="button" data-size="58">58″</button></div><label>Width (in)<input type="number" min="1" data-w></label><label>Height (in)<input type="number" min="1" data-h></label><label><input type="checkbox" checked data-lock> Keep image ratio</label><label>Preview repeat<select data-repeat><option>Basic repeat</option><option>Half-drop repeat</option><option>Mirror repeat</option><option>No repeat / placement</option></select></label><button type="button" data-save>Save size settings</button></aside></main></section>';document.body.append(m);let cv=m.querySelector('canvas'),x=cv.getContext('2d'),w=m.querySelector('[data-w]'),h=m.querySelector('[data-h]'),lock=m.querySelector('[data-lock]'),rep=m.querySelector('[data-repeat]'),pic,ratio=1;function draw(){if(!pic)return;let W=560,H=400,a=+w.value||12,b=+h.value||12,ppi=18,t=Math.max(40,a*ppi),z=Math.max(40,b*ppi);cv.width=W;cv.height=H;x.fillStyle='#f5f8fb';x.fillRect(0,0,W,H);if(rep.value==='No repeat / placement'){let q=Math.min(t/pic.width,z/pic.height);x.drawImage(pic,(W-pic.width*q)/2,(H-pic.height*q)/2,pic.width*q,pic.height*q)}else for(let row=0,y=0;y<H+z;y+=z,row++)for(let col=0,k=0;k<W+t;k+=t,col++){let dx=k-(rep.value==='Half-drop repeat'&&row%2?t/2:0);if(rep.value==='Mirror repeat'&&col%2){x.save();x.translate(dx+t,y);x.scale(-1,1);x.drawImage(pic,0,0,t,z);x.restore()}else x.drawImage(pic,dx,y,t,z)}}i.onchange=()=>{let file=i.files[0];c.hidden=!file;vw.disabled=1;msg.textContent='';if(!file)return;nm.textContent=file.name;sz.textContent=((file.size||0)/1048576).toFixed(1)+' MB';if(!/^image\/(jpeg|png|webp|gif)$/i.test(file.type)){msg.textContent='Preview unavailable for this file type; original will still be uploaded.';return}im.src=URL.createObjectURL(file);pic=new Image;pic.onload=()=>{ratio=pic.width/pic.height||1;w.value=12;h.value=Math.max(1,(12/ratio).toFixed(1));vw.disabled=0};pic.src=im.src};c.querySelector('[data-clear]').onclick=()=>{i.value='';i.onchange()};vw.onclick=()=>{m.hidden=0;m.querySelector('[data-file]').textContent=i.files[0].name;draw();w.focus()};m.onclick=e=>{if(e.target.hasAttribute('data-close'))m.hidden=1};m.querySelectorAll('[data-size]').forEach(b=>b.onclick=()=>{w.value=b.dataset.size;if(lock.checked)h.value=Math.max(1,(w.value/ratio).toFixed(1));draw()});w.oninput=()=>{if(lock.checked)h.value=Math.max(1,(w.value/ratio).toFixed(1));draw()};h.oninput=()=>{if(lock.checked)w.value=Math.max(1,(h.value*ratio).toFixed(1));draw()};rep.onchange=draw;m.querySelector('[data-save]').onclick=()=>{ww.value=w.value;hh.value=h.value;rr.value=rep.value;msg.textContent='Saved: '+w.value+'″ × '+h.value+'″ · '+rep.value;m.hidden=1};f.onsubmit=()=>{if(pic&&!ww.value){ww.value=w.value;hh.value=h.value;rr.value=rep.value}}})})();

(()=>{let s=document.createElement('style');s.textContent=".dec-artwork-card{display:grid;grid-template-columns:64px 1fr auto;gap:8px;align-items:center;margin:10px 0;padding:8px;border:1px solid #b9c9d5;border-radius:8px}.dec-artwork-card[hidden]{display:none}.dec-artwork-card img{width:64px;height:64px;object-fit:cover}.dec-artwork-card div{display:grid;gap:3px}.dec-artwork-card small{font-size:12px;color:#53657d}.dec-artwork-card button{border:0;background:transparent;color:#20345a;cursor:pointer}.dec-artwork-card [data-view]{grid-column:2;background:#20345a;color:#fff;border-radius:4px;padding:7px 12px;justify-self:start}.dec-size-modal{position:fixed;inset:0;z-index:9999;display:grid;place-items:center}.dec-size-modal[hidden]{display:none}.dec-size-modal>div{position:absolute;inset:0;background:#10233bb3}.dec-size-modal section{position:relative;width:min(900px,calc(100vw - 20px));background:#fff;border-radius:12px;overflow:auto}.dec-size-modal header{display:flex;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #ddd;font-size:20px}.dec-size-modal header button{border:0;background:none;font-size:24px}.dec-size-modal main{display:grid;grid-template-columns:1.5fr .8fr;gap:18px;padding:18px}.dec-size-modal canvas{width:100%;border:1px solid #d6e0e8}.dec-size-modal aside{display:grid;gap:9px;align-content:start}.dec-size-modal aside label{font-size:12px;color:#53657d}.dec-size-modal input[type=number],.dec-size-modal select{width:100%;box-sizing:border-box;padding:8px;margin-top:3px;border:1px solid #b9c9d5;border-radius:4px}.dec-size-modal .pres{display:flex;gap:6px}.dec-size-modal .pres button{flex:1;padding:8px;border:1px solid #c7d2de;background:#fff;border-radius:4px}.dec-size-modal [data-save]{padding:10px;background:#5f73dc;color:#fff;border:0;border-radius:5px}@media(max-width:700px){.dec-size-modal main{grid-template-columns:1fr}}";document.head.append(s)})();

(()=>{let m=document.querySelector('.dec-size-modal'),w=m&&m.querySelector('[data-w]'),h=m&&m.querySelector('[data-h]');if(!m||!w||!h||m.querySelector('[data-quick-adjust]'))return;let box=document.createElement('div');box.dataset.quickAdjust='';box.innerHTML='<label>Quick Adjust <output>12.0″</output></label><input type="range" min="1" max="58" step=".1" value="12" aria-label="Quick Adjust">';h.closest('label').after(box);let range=box.querySelector('input'),out=box.querySelector('output');function sync(){let v=Math.max(1,Math.min(58,parseFloat(w.value)||1));range.value=v;out.textContent=v.toFixed(1)+'″'}range.addEventListener('input',()=>{w.value=range.value;w.dispatchEvent(new Event('input',{bubbles:true}));sync()});w.addEventListener('input',sync);h.addEventListener('input',sync);new MutationObserver(()=>{if(!m.hidden)sync()}).observe(m,{attributes:true,attributeFilter:['hidden']});setInterval(()=>{if(!m.hidden&&document.activeElement!==range)sync()},150);sync()})();
(()=>{let s=document.createElement('style');s.textContent='.dec-size-modal [data-quick-adjust]{padding:14px 16px;margin:3px 0;background:#f5f7fa;border-radius:10px}.dec-size-modal [data-quick-adjust] label{display:flex;justify-content:space-between;align-items:center;font-size:16px;color:#53657d}.dec-size-modal [data-quick-adjust] output{font-size:16px;font-weight:700;color:#6174da}.dec-size-modal [data-quick-adjust] input{width:100%;margin:16px 0 0;accent-color:#6174da;cursor:pointer}';document.head.append(s)})();
(()=>{const s=document.createElement('style');s.textContent='.dec-library-design-preview{display:grid;grid-template-columns:112px 1fr;gap:14px;align-items:center;margin:12px 0 18px;padding:12px;border:1px solid #bfd0e3;border-radius:12px;background:#f5f8fc}.dec-library-design-preview img{width:112px;height:112px;object-fit:cover;border-radius:8px}.dec-library-design-preview figcaption{margin:0;color:#435b7b;font-size:13px;line-height:1.45}@media(max-width:560px){.dec-library-design-preview{grid-template-columns:80px 1fr}.dec-library-design-preview img{width:80px;height:80px}}';document.head.append(s)})();
